import { render, staticRenderFns } from "./ChangeUserPassword.vue?vue&type=template&id=972483a0&"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports